var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"edit-group","title":"Edit Farmer Group","hide-footer":""},on:{"shown":_vm.init}},[_c('b-overlay',{attrs:{"show":_vm.loading,"spinner-variant":"primary"}},[_c('group-form',{attrs:{"group":_vm.group},on:{"update:group":function($event){_vm.group=$event},"save-group":_vm.editGroup}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }